export default "__VITE_ASSET__HXDgWA4O__"